import React from 'react';
import { PropTypes } from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';
import Chart from 'react-apexcharts';

// Health-quadrant bubble chart. `points` = [{ x, y, z, name }].
// x = size (total users), y = engagement (% active), z = activity volume.
export function UsageBubble({ title, subtitle, points, xTitle, yTitle, height }) {
  const series = [{ name: 'Clients', data: points }];
  return (
    <Card style={{ marginBottom: 16 }}>
      <CardContent>
        <Typography component='h2' variant='h6' color='primary'>{title}</Typography>
        {subtitle && (
          <Typography variant='body2' color='textSecondary' style={{ marginBottom: 4 }}>{subtitle}</Typography>
        )}
        <Chart
          type='bubble'
          height={height || 400}
          options={{
            chart: { toolbar: { show: false }, animations: { enabled: false } },
            dataLabels: { enabled: false },
            colors: ['#148F77'],
            fill: { opacity: 0.7 },
            xaxis: { title: { text: xTitle }, tickAmount: 6, type: 'numeric' },
            yaxis: { title: { text: yTitle }, max: 100, min: 0, tickAmount: 5 },
            tooltip: {
              custom: ({ seriesIndex, dataPointIndex, w }) => {
                const p = w.config.series[seriesIndex].data[dataPointIndex];
                return (
                  '<div style="padding:6px 10px">' +
                  `<strong>${p.name || ''}</strong><br/>` +
                  `Total users: ${p.x}<br/>` +
                  `% active: ${p.y}%<br/>` +
                  `Activity: ${(p.z || 0).toLocaleString()}` +
                  '</div>'
                );
              },
            },
          }}
          series={series}
        />
      </CardContent>
    </Card>
  );
}

UsageBubble.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  points: PropTypes.array.isRequired,
  xTitle: PropTypes.string,
  yTitle: PropTypes.string,
  height: PropTypes.number,
};
